var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPenIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.243,
    height: 11.243,
    viewBox: "0 0 11.243 11.243",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-pen-alt",
    "data-name": "Icon awesome-pen-alt",
    d: "M10.933,1.629,9.613.309a1.055,1.055,0,0,0-1.491,0L6.881,1.55,9.692,4.361,10.933,3.12a1.055,1.055,0,0,0,0-1.491ZM5.514,1.178a.878.878,0,0,0-1.242,0L1.664,3.786a.351.351,0,0,0,0,.5l.5.5a.351.351,0,0,0,.5,0L4.894,2.544l.5.5L2.062,6.368A7.181,7.181,0,0,0,0,10.652v.005a.527.527,0,0,0,.582.582,7.181,7.181,0,0,0,4.289-2.06L9.195,4.858,7.377,3.041,5.514,1.178Z",
    transform: "translate(0.001 0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenIcon);
export default __webpack_public_path__ + "static/media/pen-icon.d6e6ff7c7bcca350d24238fe58508d89.svg";
export { ForwardRef as ReactComponent };